import { AdminConsoleRoutesEnum }     from '@app/modules/admin-console/routes/admin-console.routes';
import { TenantRoutesEnum }           from '@app/modules/admin-tenant/routes/admin-tenant.routes';
import { ArchivingRoutesEnum }        from '@app/modules/archiving/routes/archiving.routes';
import { BusinessPremisesRoutesEnum } from '@app/modules/business-premises/routes/business-premises.routes';
import { ClientRoutesEnum }           from '@app/modules/client/routes/client.routes';
import { ContractRoutesEnum }         from '@app/modules/contract/routes/contract.routes';
import { ErsRoutesEnum }              from '@app/modules/ers/routes/ers.routes';
import { FccVersionRoutesEnum }       from '@app/modules/fcc-version/routes/fcc-version.routes';
import { FiskalRoutesEnum }           from '@app/modules/fiskal-tss-log/routes/fiskal.routes';
import { MyAccountRoutesEnum }        from '@app/modules/my-account/routes/my-account.routes';
import { OrganizationRoutesEnum }     from '@app/modules/organization/routes/organization.routes';
import { OutageEventRoutesEnum }      from '@app/modules/outage/routes/outage.routes';
import { StructureExportRoutesEnum }  from '@app/modules/structure-export/routes/structure-export.routes';
import { StructureImportRoutesEnum }  from '@app/modules/structure-import/routes/structure-import.routes';
import { TaxationRoutesEnum }         from '@app/modules/taxation/taxation-wrapper/routes/taxation-wrapper.routes';
import { TenantConsoleRoutesEnum }    from '@app/modules/tenant-console/routes/tenant-console.routes';
import { TssRoutesEnum }              from '@app/modules/tss/routes/tss.routes';
import { CurrentUserRoutesEnum }      from '@app/modules/user/routes/current-user.routes';
import { UserRoutesEnum }             from '@app/modules/user/routes/user.routes';
import { AllowedDetailsTabEnum }      from '@core/interfaces/common.interfaces';

export enum ApiUrlSegmentEnum {
	ARCHIVING = 'archiving',
	ARCHIVING_API = 'archiving-api',
	BUSINESS_PREMISES = 'business-premises',
	CLIENTS = 'clients',
	ERS = 'ers',
	EXPORT = 'export',
	EXPORTS = 'exports',
	KEYS = 'keys',
	IMPORT = 'import',
	IMPORTS = 'imports',
	IOT_HUB = 'iot-hub',
	MANAGEMENT = 'management',
	MANIFESTS = 'manifests',
	OPEN_ARCHIVES = 'open-archives',
	OPEN_ARCHIVES_EXPORT = 'open-archives-export',
	ORGANIZATIONS = 'organizations',
	PROCEDURAL_DOCUMENTATIONS = 'procedural-documentations',
	TSS = 'tss',
	USER_MANAGEMENT = 'user-management',
	USERS = 'users',
}


export enum RouteBasePath {
	AdminConsole = 'admin-console',
	ArchivingExports = 'business-premises/archive/exports',
	ArchivingImports = 'business-premises/archive/imports',
	ArchivingProceduralDocumentations = 'business-premises/archive/documentations',
	ArchivingProceduralDocumentationExports = 'business-premises/archive/documentation-exports',
	ArchivingTssLogExports = 'business-premises/archive/tss-log-exports',
	ArchivingTssLogs = 'business-premises/archive/tss-logs',
	BusinessPremises = 'business-premises',
	Clients = 'api-access',
	Contracts = 'contracts',
	Configuration = 'configuration',
	CURRENT_USER = 'current-user',
	EncryptionKeys = 'keys',
	Ers = 'ers',
	FccVersions = 'fcc-versions',
	FiskalTssLogs = 'business-premises/:businessPremisesId/fiscal/fiskal-tss-logs',
	MyAccount = 'my-account',
	NOTIFICATIONS = 'notifications',
	OpenArchive = 'business-premises/archive/open-archives',
	OpenArchiveExport = 'business-premises/archive/open-archives-export',
	Organizations = 'organizations',
	Outages = 'business-premises/:businessPremisesId/fiscal/outages',
	StructureExport = 'structure-export',
	StructureImport = 'structure-import',
	Taxations = 'taxation',
	Tenant = 'tenant',
	TenantConsole = 'dashboard',
	Test = 'test',
	Tss = 'tss',
	Users = 'users',
}

export interface IRouteParams {
	[ key: string ]: string;

	tab?: AllowedDetailsTabEnum;
}

// TODO should actually be re-named `IRouteBaseDefinition` to better comply to our naming conventions
export interface RouteBaseDefinition {
	basePath: RouteBasePath;

	path: ApplicationRoutes;
}


export interface IRouteDefinition extends RouteBaseDefinition {
	params?: IRouteParams;

	queryParams?: object;
}

export class RouteDefinition implements IRouteDefinition {
	public id: string = undefined;

	public isActiveRoute: boolean = undefined;

	public basePath: RouteBasePath = undefined;

	public path: ApplicationRoutes = undefined;

	public params?: IRouteParams = undefined;

	public queryParams?: object = undefined;

	public replaceLastStoredRouteWithNew?: boolean;
}


export type ApplicationRoutes =
	AdminConsoleRoutesEnum |
	ArchivingRoutesEnum |
	BusinessPremisesRoutesEnum |
	ClientRoutesEnum |
	ContractRoutesEnum |
	CurrentUserRoutesEnum |
	ErsRoutesEnum |
	FccVersionRoutesEnum |
	FiskalRoutesEnum |
	MyAccountRoutesEnum |
	OrganizationRoutesEnum |
	OutageEventRoutesEnum |
	StructureExportRoutesEnum |
	StructureImportRoutesEnum |
	TaxationRoutesEnum |
	TenantConsoleRoutesEnum |
	TenantRoutesEnum |
	TssRoutesEnum |
	UserRoutesEnum;
